import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { QuizQuestionsFacade } from '../facades/quiz-questions.facade';

export function quizQuestionsCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const quizQuestionsFacade = inject(QuizQuestionsFacade);
        quizQuestionsFacade.clear();

        return true;
    };
}
